module.exports = __webpack_public_path__ + "static/media/4.Monoblock pumps (0.5 Hp - 2Hp).bfe7500a.jpg";